import { type cbhFeatureFlags } from "@src/appV2/FeatureFlags/CbhFeatureFlags";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { type z } from "zod";

import { CbhFeatureFlag } from "../../../FeatureFlags/CbhFeatureFlag";

export type InAppAdsFlag = z.infer<(typeof cbhFeatureFlags)[CbhFeatureFlag.IN_APP_ADS]>;

export function useInAppAdsFlag(): InAppAdsFlag {
  return useCbhFlag(CbhFeatureFlag.IN_APP_ADS, {
    defaultValue: { enabled: false, ads: [] },
  });
}
